<template>
  <div class="upload-detail">
    <div class="info-item title">{{ $t('shared.inviteFansToJoinTheCommunity') }}</div>
    <div class="info-item person-info">
      <span class="user-name txt-ellipsis">{{ infoObj.nickname }}</span>
      <span class="user-type txt-ellipsis" v-if="infoObj.job">{{ infoObj.job }}</span>
    </div>
    <div class="info-item">{{ $t('shared.store') }}： <span class="store-name" @click="toUrl">{{ infoObj.customerName }}</span></div>
    <div class="info-item">{{ $t('shared.submissionTime') }}：{{ infoObj.localCreateTime }}</div>
    <div class="info-item">{{ $t('shared.titleSeventeen', { totalIntegral: infoObj.totalIntegral }) }}</div>
  </div>
</template>

<script>
export default {
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toUrl () {
      this.$router.push(`/storeExpansion/storeMappingDetail?customerId=${this.infoObj.customerId}`)
    }
  }
}
</script>

<style lang="less" scoped>
.upload-detail {
  flex: 1;
  padding: 28px 23px;
  font-size: 13px;
  .info-item {
    padding: 6px 0;
  }
  .store-name {
    color: #307bff;
    text-decoration: underline;
  }
  .person-info {
    display: flex;
    align-items: center;
    .user-name {
      max-width: 170px;
    }
    .user-type {
      max-width: 85px;
      padding: 2px 5px;
      text-align: center;
      border: 1px solid #307bff;
      color: #307bff;
      margin-left: 5px;
      font-size: 12px;
    }
  }
  .title {
    font-weight: bold;
  }
  .img-content {
    display: flex;
    .item-img {
      flex: 1;
    }
  }
  .img-icon {
    width: 48px;
    height: 48px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
